import script from "./sourcetype-select.vue?vue&type=script&setup=true&lang=js"
export * from "./sourcetype-select.vue?vue&type=script&setup=true&lang=js"

import "./sourcetype-select.vue?vue&type=style&index=0&id=45c5767e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45c5767e"]])

export default __exports__